import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PageTitle from '../../../components/commons/pages/PageTitle';
import Loader from '../../../components/commons/loader/loader';
import * as User from '../../../utils/userHelpers';
import * as Cart from '../../../utils/cartHelper';
import SweetAlert from 'sweetalert-react';
import * as UserActions from '../../../actions/userActions';
import withSizes from 'react-sizes';
import Moment from 'moment-timezone';
class StripeFailureResponsePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLoggedIn: false,
    };

    this.renderOrderInterupptedMessage = this.renderOrderInterupptedMessage.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {

    const that = this;
   

    if (!User.isLoggedIn()) {
      return;
    } else {
      this.setState({ isUserLoggedIn: true });
    }
    let cartItems = Cart.getCartAttribute(Cart.ATTRIBUTE_CART_ITEMS);

    const products = Object.values(cartItems).map(i => ({
      id: i._id,
      name: i.Description,
      ...i
    }));
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: { checkout: { actionField: { step: 1 }, products } }
    });

  }
  componentWillUnmount() {
    window.removeEventListener('cart_changed', this.updateCart);
  }


  render() {
    const { swalParams, showAlert } = this.state;
    const { loading, isMobile } = this.props;

    console.log('REVIEW_ORDER_PAGE_STATE', this.state);
    // console.log('REVIEW_ORDER_PAGE_PROPS', this.props);

    return (
      <div className={`page checkout-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          <PageTitle title="Review & Place Order" isMobile />
          {this.renderOrderInterupptedMessage()}
          

        </div>
        <Loader visibility={loading} />
        <SweetAlert showCancelButton
          customClass={"with-close"}
          cancelButtonText={"x"}
          onCancel={() => this.setState({ showAlert: false })}
          show={showAlert}
          {...swalParams}
          onConfirm={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  goBack() {
    this.props.history.goBack();
  }

  renderOrderInterupptedMessage() {
    const query = new URLSearchParams(this.props.location.search);
    const orderId = query.get('orderId');

    return (
      <div className="message-container">
        <div className="title">Your order was interuppted .</div>
        <div className="info-message">To continue submit the payment.</div>
        <div className="links">
          {/* <Link to="/">Continue Shopping</Link> */}
          <Link to={`/orders/${orderId}`}>View Pending Order</Link>
        </div>
      </div>
    )
  }
 

}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    deliveryPlace: state.getIn(['orders', 'deliveryPlace']),
    stripeCustomer: state.getIn(['payments', 'stripeCustomer']),
    loading: (state.getIn(['products', 'loading']) || state.getIn(['payments', 'loading']) || state.getIn(['orders', 'loading'])),
    shippoLoading: (state.getIn(['orders', 'shippoLoading'])),
    error: state.getIn(['products', 'error']),
    cards: state.getIn(['payments', 'cards']),
    user: state.getIn(['users', 'user']),
  };
})(StripeFailureResponsePage));



// WEBPACK FOOTER //
// ./src/containers/billing/checkout/StripeFailureResponsePage.js